import { createFileRoute } from '@tanstack/react-router'

import { PricingUsagePage } from '#/modules/loadboards/pricing-usage-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/pricing-usage')({
  component: PricingUsagePage,
  validateSearch: validateListSearch,
})
